module.exports = __webpack_public_path__ + "img/DiaryBarham.9dba738e.jpg";